import { render, staticRenderFns } from "./SOWModal.vue?vue&type=template&id=80de0cb2"
import script from "./SOWModal.vue?vue&type=script&lang=js"
export * from "./SOWModal.vue?vue&type=script&lang=js"
import style0 from "./SOWModal.vue?vue&type=style&index=0&id=80de0cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports